/** @format — Chats empty states (list empty + no selection panel) */

import React from "react";
import IllustrationEmptyState from "@/components/ui/IllustrationEmptyState";

export default function ChatEmptyState({
  title = "No conversations yet",
  description = "Start a chat with Dockie to get help with shipments, documents, ports, pricing, or tracking.",
  actionLabel = "Start new chat",
  onAction,
  loading = false,
  className = "",
}) {
  return (
    <IllustrationEmptyState
      title={title}
      description={description}
      actionLabel={onAction ? actionLabel : undefined}
      onAction={onAction}
      loading={loading}
      className={className}
    />
  );
}
